module.exports = __webpack_public_path__ + "assets/img/y3.c5eecc87.png";